import "@/index.css";
import { AppRouter } from "./core/routing/AppRouter";
import { AuthProvider } from "./core/auth/contexts/AuthProvider";
import { AppRoutes } from "./core/routing/routes";
import { ProfileProvider } from "./features/profile/contexts/ProfileProvider";
import { useNavigationIdentity } from "./core/routing/NavigationContext";

function AppContent() {
  const onIdentityChange = useNavigationIdentity();
  return (
    <AuthProvider onIdentityChange={onIdentityChange}>
      <ProfileProvider>
        <AppRoutes />
      </ProfileProvider>
    </AuthProvider>
  );
}

function App() {
  return (
    <AppRouter>
      <AppContent />
    </AppRouter>
  );
}

export default App;
